import { HttpClient } from "@angular/common/http";
import { computed, inject, Injectable, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { ApiResponse, Directory } from "app/@core/types";
import { environment } from "environments/environment";
import { map, of } from "rxjs";
import { UserService } from "./users.service";

@Injectable({ providedIn: "root" })
export class DirectoryService {
  private userService = inject(UserService);
  private http = inject(HttpClient);
  baseUrl: string = environment.baseUrl + "courses/directory";

  readonly activeCourseId = signal<number | null>(null);
  readonly activePeepId = signal<number | null>(null);
  readonly isAllowed = computed(() => this.userService.inDirecory());

  directoryResource = rxResource({
    request: () => {
      const isAllowed = this.isAllowed();
      const courseId = this.activeCourseId();
      return isAllowed ? { allowed: true, courseId } : null;
    },
    loader: ({ request }) => {
      if (!request || !request.courseId) return of([]);
      const { courseId } = request;
      return this.http.get<ApiResponse>(`${this.baseUrl}/${courseId}/all`).pipe(
        map((res: ApiResponse) => {
          if (res.status === "ok") {
            return res.data as Directory[];
          }
          throw new Error("Directoy not found not found");
        }),
      );
    },
  });

  //clean signal for the UI
  readonly peeps = computed(() => this.directoryResource.value() ?? []);

  readonly peepProfileResource = rxResource({
    request: () => this.activePeepId(),
    loader: ({ request }) => {
      if (!request) return of(null);
      return this.http
        .get<ApiResponse>(`${this.baseUrl}/profile/${this.activePeepId()}`)
        .pipe(
          map((res: ApiResponse) => {
            if (res.status === "ok") {
              return res.data as Directory;
            }
            throw new Error("Profile not found");
          }),
        );
    },
  });

  // Method to trigger the load from the component
  loadCourseDirectory(courseId: number) {
    this.activeCourseId.set(courseId);
  }

  setPeepId(peepId: number) {
    this.activePeepId.set(peepId);
  }

  load(id: number) {
    return this.http.get<ApiResponse>(this.baseUrl + "/profile/" + id);
  }

  unload(): void {
    this.activeCourseId.set(null);
  }
}
